import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/phoneQuestionFileNew.vue';
export default {
  name: 'fillInTheBlanks',
  components: {
    QuestionFile: QuestionFile
  },
  props: {
    isBook: {
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: false
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.cont = this.data;
    this.questions = this.data.Selects;
    this.CheckValues = this.data.Answers;
    this.content = this.data.Analysis;

    if (this.data.Answers) {
      this.questions = this.data.Answers;
    } // 题目附件


    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  },
  data: function data() {
    return {
      urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
      // 题干附件
      fileList: [],
      fileIds: [],
      // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      anaShow: true,
      showThisAnswer: true,
      cont: [],
      content: '请输入内容',
      formOption: {
        choice: null
      },
      questions: [],
      a: 1,
      CheckValues: [],
      check: [],
      alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };
  },
  watch: {},
  methods: {
    upDown: function upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    },
    // 添加选项
    addChoice: function addChoice() {
      var n = this.questions.length;
      var str = {
        id: n,
        contrary: false,
        choice: this.alphabet[n]
      };
      this.questions.push(str);
      this.CheckValues.push(null);
    },
    // 删除选项
    closeChoice: function closeChoice(index) {
      for (var i = 0; i <= index; i++) {
        this.questions[i].choice = this.alphabet[i];
      }

      this.questions.splice(index, 1);
      this.CheckValues = this.check;
    },
    // 添加正确答案
    addCheckValue: function addCheckValue() {
      this.CheckValues = this.check;
    },
    // 做作业是选择答案
    doCheckValue: function doCheckValue() {
      this.$emit('getAnswer', {
        Id: this.cont.Id,
        Answers: this.questions
      });
    }
  }
};